"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCalendarRangeBehavior = void 0;
var bc_date_constants_1 = require("./bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_calendar_behavior_utilities_1 = require("./bc-calendar-behavior-utilities");
var helpers_1 = require("../../../common/helpers");
var BcCalendarRangeBehavior = (function () {
    function BcCalendarRangeBehavior() {
        this.bcCalendarUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
    }
    BcCalendarRangeBehavior.prototype.setUpMinAndMaxDate = function (calendarBehavior, min, max) {
        if (min && !isNaN(Date.parse(min))) {
            calendarBehavior.minDate = new Date(min);
            calendarBehavior.minDate.setUTCHours(0, 0, 0, 0);
        }
        if (max && !isNaN(Date.parse(max))) {
            calendarBehavior.maxDate = new Date(max);
            calendarBehavior.maxDate.setUTCHours(0, 0, 0, 0);
        }
    };
    BcCalendarRangeBehavior.prototype.addListenersForSplitSelectorCalendar = function (calendarBehavior) {
        var _this = this;
        this.addListenerToMonthBtn(calendarBehavior);
        calendarBehavior.monthTopBar.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            calendarBehavior.setElementsForMonthSelector();
            event.stopPropagation();
        }, { once: true });
        calendarBehavior.prevYearBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            event.stopPropagation();
        });
        calendarBehavior.yearTopBar.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            calendarBehavior.setElementsForYearSelector();
            event.stopPropagation();
        }, { once: true });
        calendarBehavior.nextYearBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            event.stopPropagation();
        });
        this.addLestenerEnterKeyForSplitSelectorCalendar(calendarBehavior);
    };
    BcCalendarRangeBehavior.prototype.addLestenerEnterKeyForSplitSelectorCalendar = function (calendarBehavior) {
        var _this = this;
        this.addEnterKeyListener(calendarBehavior.nextYearBtn, function () {
            _this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], 1, calendarBehavior);
            calendarBehavior.nextYearBtn.focus();
        });
        this.addEnterKeyListener(calendarBehavior.monthTopBar, function () {
            calendarBehavior.setElementsForMonthSelector();
        });
        this.addEnterKeyListener(calendarBehavior.prevYearBtn, function () {
            _this.bcCalendarUtilities.displaceYears(calendarBehavior.displayedMonths[0], -1, calendarBehavior);
            calendarBehavior.prevYearBtn.focus();
        });
        this.addEnterKeyListener(calendarBehavior.yearTopBar, function () {
            calendarBehavior.setElementsForYearSelector();
        });
    };
    BcCalendarRangeBehavior.prototype.addListenerToMonthBtn = function (calendarBehavior) {
        var _this = this;
        calendarBehavior.prevMonthBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.prevMonthBtn, function (event) {
            _this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            calendarBehavior.prevMonthBtn.focus();
            event.stopPropagation();
        });
        calendarBehavior.nextMonthBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.nextMonthBtn, function (event) {
            _this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
            calendarBehavior.nextMonthBtn.focus();
            event.stopPropagation();
        });
    };
    BcCalendarRangeBehavior.prototype.addEnterKeyListener = function (element, Do) {
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                Do();
            }
        });
    };
    BcCalendarRangeBehavior.prototype.addMonthsPicker = function (calendarBehavior, language) {
        for (var i = 0; i < this.bcCalendarUtilities.getListMonthByLanguage(language).length; i++) {
            var month = document.createElement('p');
            month.textContent = this.bcCalendarUtilities.getListMonthByLanguage(language)[i].substring(0, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N3);
            if (calendarBehavior.today.getMonth() == i &&
                calendarBehavior.today.getFullYear() == calendarBehavior.displayedMonths[0].year) {
                month.classList.add(bc_date_constants_1.BcDateConstants.THIS_MONTH_OR_YEAR_CLASS);
            }
            calendarBehavior.monthsOrYearsContainer.appendChild(month);
            (0, helpers_1.addFocusable)(month, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(month);
            month.setAttribute(bc_date_constants_1.BcDateConstants.ID, "".concat(bc_date_constants_1.BcDateConstants.ID_MONTH).concat(i));
            month.setAttribute(bc_date_constants_1.BcDateConstants.MONTH_NUMBER, "".concat(i));
            this.bcCalendarUtilities.keyReader(month, calendarBehavior);
            this.addListenerToSelectMonth(month, i, calendarBehavior);
        }
    };
    BcCalendarRangeBehavior.prototype.addListenerToSelectMonth = function (element, index, calendarBehavior) {
        this.validateMonthDisabled(element, calendarBehavior, index);
    };
    BcCalendarRangeBehavior.prototype.validateMonthDisabled = function (month, calendarBehavior, index) {
        var _this = this;
        var dayEnabled = true;
        if (calendarBehavior.minDate || calendarBehavior.maxDate) {
            var year = month.parentElement.parentElement.getElementsByClassName(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS)[0].querySelector(common_constants_1.BcCommonConstants.H6_TAG).innerHTML;
            var dayFullDate = new Date("".concat(year, "-").concat(Number(month.getAttribute('month_number')) + 1, "-").concat(1));
            dayFullDate.setUTCHours(0, 0, 0, 0);
            if (calendarBehavior.minDate && dayFullDate < calendarBehavior.minDate) {
                dayEnabled = false;
            }
            if (calendarBehavior.maxDate && dayFullDate > calendarBehavior.maxDate) {
                dayEnabled = false;
            }
        }
        if (dayEnabled) {
            month.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                calendarBehavior.selectMonth(index, calendarBehavior.displayedMonths[0]);
                if (_this.getFormatAttributte(calendarBehavior) === bc_date_constants_1.DateFormate.mediumDate) {
                    calendarBehavior.selectCalendarOption(month, _this.getFormatAttributte(calendarBehavior));
                }
                event.stopPropagation();
            });
        }
        else {
            month.classList.add(bc_date_constants_1.BcDateConstants.DISABLED_MONTH);
        }
        return dayEnabled;
    };
    BcCalendarRangeBehavior.prototype.getFormatAttributte = function (calendarBehavior) {
        var _a;
        return (_a = calendarBehavior.calendarsContainer.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.querySelectorAll('input')[0].getAttribute(bc_date_constants_1.BcDateConstants.FORMAT_DATE);
    };
    BcCalendarRangeBehavior.prototype.nextYearGroup = function (calendarBehavior) {
        var displayedMonth = calendarBehavior.displayedMonths[0];
        displayedMonth.year += bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12;
        calendarBehavior.yearGroup = [displayedMonth.year - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11, displayedMonth.year];
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    };
    BcCalendarRangeBehavior.prototype.addListenerToSelectDate = function (element, calendarBehavior) {
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            calendarBehavior.selectCalendarOption(element, bc_date_constants_1.DateFormate.fullDate);
            event.stopPropagation();
        });
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUS, function () {
            calendarBehavior.focus = element.textContent;
        });
    };
    BcCalendarRangeBehavior.prototype.maxAndMinDate = function (monthInfo, dayNumber, dayEnabled, day, calendarBehavior) {
        if (calendarBehavior.minDate || calendarBehavior.maxDate) {
            var dayFullDate = new Date("".concat(monthInfo.year, "-").concat(monthInfo.month + 1, "-").concat(dayNumber));
            dayFullDate.setUTCHours(0, 0, 0, 0);
            if (calendarBehavior.minDate && dayFullDate < calendarBehavior.minDate) {
                dayEnabled = false;
            }
            if (calendarBehavior.maxDate && dayFullDate > calendarBehavior.maxDate) {
                dayEnabled = false;
            }
        }
        if (dayEnabled) {
            this.addListenerToSelectDate(day, calendarBehavior);
        }
        else {
            day.classList.add(bc_date_constants_1.BcDateConstants.DISABLED_DAY);
        }
        return dayEnabled;
    };
    BcCalendarRangeBehavior.prototype.createAMonthElement = function (monthInfo, topBar, calendarBehavior, language, holidays) {
        var configMonthElements = this.bcCalendarUtilities.configMonthElement(topBar, monthInfo, language);
        for (var dayNumber = 1 - configMonthElements.emptyDays; dayNumber <= this.bcCalendarUtilities.getNumberOfDays(monthInfo.month, monthInfo.year); dayNumber++) {
            this.creatingAMonthElement(dayNumber, configMonthElements, monthInfo, calendarBehavior, holidays);
        }
        return configMonthElements.element;
    };
    BcCalendarRangeBehavior.prototype.creatingAMonthElement = function (dayNumber, configMonthElements, monthInfo, calendarBehavior, holidays) {
        if (dayNumber < 1) {
            var empty = document.createElement('div');
            configMonthElements.month.appendChild(empty);
        }
        else {
            var day = document.createElement('p');
            var dayEnabled = true;
            day.classList.add(common_constants_1.BcCommonConstants.SMALL, bc_date_constants_1.BcDateConstants.DAY);
            day.textContent = dayNumber < 1 ? '' : dayNumber.toString();
            configMonthElements.month.appendChild(day);
            configMonthElements.tempDate.setDate(dayNumber);
            if (configMonthElements.tempDate.toDateString() == calendarBehavior.today.toDateString()) {
                day.classList.add(bc_date_constants_1.BcDateConstants.TODAY_CLASS);
            }
            if (holidays) {
                this.bcCalendarUtilities.holidays(dayNumber, monthInfo, day, holidays);
            }
            (0, helpers_1.addFocusable)(day, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(day);
            this.bcCalendarUtilities.setDayAttribute(day, monthInfo);
            dayEnabled = calendarBehavior.bcCalendarRange.maxAndMinDate(monthInfo, dayNumber, dayEnabled, day, calendarBehavior);
            this.bcCalendarUtilities.keyReader(day, calendarBehavior, dayEnabled);
        }
    };
    BcCalendarRangeBehavior.prototype.addListenersForPrevAndNextBtns = function (calendarBehavior) {
        var _this = this;
        calendarBehavior.next.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.nextAction(calendarBehavior),
                { once: true, };
            event.stopPropagation();
        });
        calendarBehavior.prev.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.prevAction(calendarBehavior),
                { once: true, };
            event.stopPropagation();
        });
    };
    BcCalendarRangeBehavior.prototype.prevAction = function (calendarBehavior) {
        var _this = this;
        if (calendarBehavior.calendarState === bc_date_constants_1.BcDateConstants.STATE_DAYS) {
            this.bcCalendarUtilities.goToPreviousMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
        }
        else if (calendarBehavior.calendarState === bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            calendarBehavior.displayedMonths.forEach(function (item) {
                _this.bcCalendarUtilities.goToPreviousMonth(item);
            });
            calendarBehavior.setUpDisplayedMonthElement();
        }
        calendarBehavior.addBorderSelectedDates();
    };
    BcCalendarRangeBehavior.prototype.previousYearGroup = function (displayedMonth, calendarBehavior) {
        displayedMonth.year -= 12;
        calendarBehavior.yearGroup = [displayedMonth.year - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11, displayedMonth.year];
        calendarBehavior.setElementsWithCalendarState(displayedMonth);
    };
    BcCalendarRangeBehavior.prototype.nextAction = function (calendarBehavior) {
        var _this = this;
        if (calendarBehavior.calendarState === bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            calendarBehavior.displayedMonths.forEach(function (item) {
                _this.bcCalendarUtilities.goToNextMonth(item);
            });
            calendarBehavior.setUpDisplayedMonthElement();
        }
        else {
            this.bcCalendarUtilities.goToNextMonth(calendarBehavior.displayedMonths[0]);
            calendarBehavior.setUpDisplayedMonthElement(calendarBehavior.displayedMonths[0]);
        }
        calendarBehavior.addBorderSelectedDates();
    };
    BcCalendarRangeBehavior.prototype.addListenerToBtnYearGroup = function (calendarBehavior) {
        var _this = this;
        (0, helpers_1.addFocusable)(calendarBehavior.next, { tabindex: '0' });
        (0, helpers_1.addFocusable)(calendarBehavior.prev, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(calendarBehavior.next);
        this.bcCalendarUtilities.focusListeners(calendarBehavior.prev);
        calendarBehavior.next.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.nextYearGroup(calendarBehavior);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.next, function (event) {
            _this.nextYearGroup(calendarBehavior);
            event.stopPropagation();
        });
        calendarBehavior.prev.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.previousYearGroup(calendarBehavior.displayedMonths[0], calendarBehavior);
            event.stopPropagation();
        });
        this.addEnterKeyListener(calendarBehavior.prev, function (event) {
            _this.previousYearGroup(calendarBehavior.displayedMonths[0], calendarBehavior);
            event.stopPropagation();
        });
    };
    BcCalendarRangeBehavior.prototype.automaticRange = function (daysToGoBack, calendarBehavior) {
        if (calendarBehavior.date == null) {
            calendarBehavior.date = calendarBehavior.today;
        }
        var dateToSelect = new Date(calendarBehavior.date.getFullYear(), calendarBehavior.date.getMonth(), calendarBehavior.date.getDate() - daysToGoBack);
        calendarBehavior.dateTwo = dateToSelect;
        calendarBehavior.addDatesToArraySelectRangeAndSort();
        calendarBehavior.btnConfirm.removeAttribute('disabled');
        calendarBehavior.addBorderSelectedDates();
    };
    return BcCalendarRangeBehavior;
}());
exports.BcCalendarRangeBehavior = BcCalendarRangeBehavior;
